export enum BackgroundWidth {
  PAGE_WIDE = 'SCREEN_WIDE',
  CONTENT_WIDE = 'CONTENT_WIDE',
}
